if ($('#products').length) {
    (function () {
        $(function () {
            var action = $('#frmRestaurantMenu').attr('action');
            subwayScript.showSpinner();
            subwayScript.showSpinner1();
            ajaxGetResults(action, 'frmRestaurantMenu');
        });

        var $restaurantID = $("input[name=RestaurantId]");
        if ($restaurantID != null) {
            storeID = subwayScript.checkSatelliteNumber($restaurantID.val());
            createCartInCategories(storeID);
        }
        function ajaxGetResults(postUrl, formId) {
            $.ajax({
                url: postUrl,
                type: 'POST',
                data: $('#' + formId).serialize(),
                success: function (data) {
                    $('#prod-loader').hide();


                    if (data.Error !== undefined) {
                        if (data.Error.Url !== null && data.Error.Url !== undefined) {
                            window.location.href = data.Error.Url;
                        }
                    }
                    var html = $.parseHTML(data);
                    var categoryNameInput = $(html).filter('#category-name-input');

                    $('nav > .category-title').html(categoryNameInput.val());

                    $('#products-list').html(data);

                    var categories = [];
                    var categoryName = $('#category-name-input').val();
                    categories.push(categoryName);
                    analytics.pageProducts('', categories, '', '');
                    subwayScript.hideSpinner();
                    subwayScript.hideSpinner1();
                },
                error: function (jqXhr) {
                    subwayScript.hideSpinner();
                    subwayScript.showAjaxError(jqXhr);
                    subwayScript.hideSpinner1();
                }
            });
        }

    })();
}
$(document).on('click', '.categoryNameClick', function () {
    var buttonText = $(this).text().trim();
    analytics.somethingDifferentClick(buttonText, false);
});

$(document).ready(function () {
    if (!window.location.href.includes("locator")) {
        orderViewModel.targetlocator = window.location.href;
        orderViewModel.save()
    }
    if (!isCurrentPage('miam') && !isCurrentPage('customizer')) {
        orderViewModel.kidsMealData.currentItems = null
        orderViewModel.kidsMealData.isMiamCancelClicked = false
        sessionStorage.setItem('isKidsMeal', false);
        orderViewModel.save()
    }
    if ($("#root-react").length) {
        const hiddenValues = $("#customizer-json-values").val() || "{}";
        const restaurantID = JSON.parse(hiddenValues).RestaurantId

        if (restaurantID) {
            createCartInCategories(restaurantID);
        }
    }
    if (isCurrentPage('menu')) {
        orderViewModel.subCategory = '';
        orderViewModel.save();
    }
    if (orderViewModel.hasLoggedIn) {
        analytics.setStoreIsoCodes(orderViewModel.Analytics.guestCountry);
    }
    else {
        analytics.setStoreIsoCodes(analytics.fallbackCountry);
    }

});

const selectCurrentSubCategoryTab = (data) => {
    //For selecting the current category tab
    $(".category_tab_link").filter(function () {
        return $.trim($(this).text().toLowerCase()) == $.trim(data.toLowerCase());
    }).attr("aria-current", "page").children().addClass('selected_tab');
};

const scrollToSelectedTab = () => {
    const element = $(".selected_tab")[0];
    element ? element.scrollIntoView({
        behavior: "smooth",
        inline: "center"
    }) : null;
};

const implementDraggableScroll = (class_container) => {
    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
    const class_name = "." + class_container;
    if (isDesktop && class_container) {
        //For draggable scroll using mouse on categories tab
        const slider = document.querySelector(class_name);
        let isDown = false;
        let startX;
        let scrollLeft;

        slider.addEventListener('mousedown', (e) => {
            e.preventDefault()
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', (e) => {
            e.preventDefault();
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mouseup', (e) => {
            e.preventDefault()
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mousemove', (e) => {
            e.preventDefault();
            if (!isDown) return;
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 1; //scroll-fast
            slider.scrollLeft = scrollLeft - walk;
        });
    }
};

const executeDisplayTabFilterAsync = dataValues => {
    const resultBindingId = $('#display_tabs');
    $.ajax({
        url: '/RemoteOrder/Menu/DisplayTabFilterAsync',
        type: 'POST',
        data: dataValues,
        success: function (data) {
            resultBindingId.html(data);
            selectCurrentSubCategoryTab(orderViewModel.selectedCategory);
            scrollToSelectedTab();
        }
    });
};

const subCategoryClickAction = (button_text = "") => {
    setSelectedCategory(button_text);
    analytics.categoryPageAction(button_text);
};

const setSelectedCategory = (button_text = "") => {
    orderViewModel.selectedCategory = button_text;
    orderViewModel.save();
}

